module.exports = __webpack_public_path__ + "img/pan.6d93e433.png";